import React, { useState } from "react";
import Slider from "react-slick";
import tw from "twin.macro";
import styled from "styled-components";
import { SectionHeading } from "components/misc/Headings";
import { PrimaryButton as PrimaryButtonBase } from "components/misc/Buttons";
import { ReactComponent as PriceIcon } from "feather-icons/dist/icons/dollar-sign.svg";
import { ReactComponent as LocationIcon } from "feather-icons/dist/icons/map-pin.svg";
import { ReactComponent as StarIcon } from "feather-icons/dist/icons/arrow-up.svg";
import { useNavigate } from "react-router-dom";
import { CARDS_REFERENCE } from "./show_property_cards_config";
import PropertyCard from "./PropertyCard";
import { SECTION_SPACING_IN_REM } from "config/layout_config";
export const Container = tw.div`relative`;
export const Content = styled.div`
  padding-top: ${SECTION_SPACING_IN_REM}rem;
  ${tw`max-w-screen-xl mx-auto`}
`;
export const HeadingWithControl = tw.div`flex flex-col items-center sm:items-stretch sm:flex-row justify-between`;
export const Heading = tw(SectionHeading)`text-center lg:text-left`;
export const Controls = tw.div`flex items-center`;
export const CardSlider = styled(Slider)`
  ${tw`mt-16`}
  .slick-track {
    ${tw`flex justify-center lg:justify-around`}
    gap: 2rem;
  }
  .slick-slide {
    ${tw`h-auto flex justify-center mb-1`}
  }
`;
/**5px 13px 6px -6px rgba(0,0,0,0.4) hover:shadow-[6px 16px 12px -4px rgb(0 0 0 / 55%)]  */
export const Card = tw.div`h-full  transition-all flex! mx-2 w-[18rem]  lg:min-w-[22rem] flex-col sm:border sm:rounded-tl-4xl sm:rounded-br-5xl relative focus:outline-none`;
// export const Card = tw.div`h-full shadow-card transition-all flex! mx-2 max-w-sm w-[14rem] lg:min-w-[22rem] flex-col sm:border sm:rounded-tl-4xl sm:rounded-br-5xl relative focus:outline-none`;

export const CardImage = styled.div((props) => [
  `background-image: url("${props.imageSrc}");height: 14rem !important;`,
  tw`w-full h-48 sm:h-64 bg-cover bg-center rounded sm:rounded-none sm:rounded-tl-4xl`,
]);

export const TextInfo = tw.div`py-4 sm:px-10 sm:py-4`;
export const TitleReviewContainer = tw.div`flex flex-col sm:flex-row sm:justify-between sm:items-center`;
export const Title = tw.h5`text-2xl text-center lg:text-left font-bold`;

export const RatingsInfo = styled.div`
  ${tw`flex items-center sm:ml-4 mt-2 sm:mt-0`}
  svg {
    ${tw`w-6 h-6 text-yellow-500 fill-current`}
  }
`;
export const Rating = tw.span`ml-2 font-bold`;

export const Description = tw.p`text-sm leading-loose mt-2 sm:mt-4`;

export const SecondaryInfoContainer = tw.div`flex w-[100%] justify-between flex-col sm:flex-row mt-1 sm:mt-3`;
export const IconWithText = tw.div`flex items-center w-[100%] lg:flex-row   my-2 sm:my-0`;
// export const IconWithText = tw.div`flex items-center w-[100%]  flex-col lg:flex-row justify-between my-2 sm:my-0`;

export const IconContainer = styled.div`
  ${tw`inline-block rounded-full p-2 bg-gray-700 text-gray-100`}
  svg {
    ${tw`w-3 h-3`}
  }
`;
export const Text = tw.p`text-[12px] text-gray-800`;
export const Text2 = tw.p`text-[12px] ml-2 text-sm font-bold text-purple-800`;

export const PrimaryButton2 = tw(
  PrimaryButtonBase
)`mt-auto sm:text-lg rounded-none w-full rounded`;

export const PrimaryButton = tw(
  PrimaryButtonBase
)`mt-auto sm:text-lg rounded-none w-full rounded sm:rounded-none sm:rounded-br-4xl py-3 sm:py-6`;
export default () => {
  const navigate = useNavigate();
  // useState is used instead of useRef below because we want to re-render when sliderRef becomes available (not null)
  const [sliderRef, setSliderRef] = useState(null);
  const sliderSettings = {
    arrows: false,
    lazyLoad: true,
    slidesToShow: 3,
    variableWidth: true,
    responsive: [
      {
        breakpoint: 1280,
        settings: {
          slidesToShow: 2,
        },
      },

      {
        breakpoint: 900,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
      {
        breakpoint: 200,
        settings: {
          slidesToShow: 1,
          slidesToScroll: 1,
        },
      },
    ],
  };

  /* Change this according to your needs */

  return (
    <Container>
      <Content>
        <HeadingWithControl>
          <Heading>Popular Projects</Heading>
          <Controls>
            <PrimaryButton2
              onClick={() => navigate("/all-list", { state: CARDS_REFERENCE })}
            >
              More Properties
            </PrimaryButton2>
          </Controls>
        </HeadingWithControl>
        <CardSlider ref={setSliderRef} {...sliderSettings}>
          {CARDS_REFERENCE.map((card, index) => (
            <PropertyCard cardInstance={card} {...card} />
          ))}
        </CardSlider>
      </Content>
    </Container>
  );
};
